import { t as e } from "./utils-DiFe-_ei.js";
import { i as t, r as n, t as r } from "./dist-By11B3Nf.js";
import { a as i } from "./dist-7tgynhKG.js";
import { t as a } from "./dist-B3lndwlS.js";
import { t as o } from "./dist-CUIQpIad.js";
import { t as s } from "./check-hnLqiRGn.js";
import { t as c } from "./dist-5NoialTu.js";
import * as l from "react";
import { Fragment as u, jsx as d, jsxs as f } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-checkbox@1.3.8_@types+react-dom@19.2.3_@types+react@19.2.17__@types+rea_aa48c49a9d934ffcff3348879e48bdde/node_modules/@radix-ui/react-checkbox/dist/index.mjs
var p = Object.defineProperty, m = (e, t) => p(e, "name", {
	value: t,
	configurable: !0
}), h = "Checkbox", [g, _] = t(h), [v, y] = g(h);
function b(e) {
	let { __scopeCheckbox: t, checked: n, children: i, defaultChecked: a, disabled: o, form: s, name: c, onCheckedChange: u, required: f, value: p = "on", internal_do_not_use_render: m } = e, [g, _] = r({
		prop: n,
		defaultProp: a ?? !1,
		onChange: u,
		caller: h
	}), [y, b] = l.useState(null), [x, S] = l.useState(null), C = l.useRef(!1), [w, T] = l.useReducer((e) => e + 1, 0), E = !y || !!s || !!y.closest("form"), D = {
		checked: g,
		disabled: o,
		setChecked: _,
		control: y,
		setControl: b,
		name: c,
		form: s,
		value: p,
		hasConsumerStoppedPropagationRef: C,
		userInteractionCount: w,
		onUserInteraction: T,
		required: f,
		defaultChecked: !k(a) && a,
		isFormControl: E,
		bubbleInput: x,
		setBubbleInput: S
	};
	return /* @__PURE__ */ d(v, {
		scope: t,
		...D,
		children: O(m) ? m(D) : i
	});
}
m(b, "CheckboxProvider");
var x = "CheckboxTrigger", S = /* @__PURE__ */ l.forwardRef(/* @__PURE__ */ m(function({ __scopeCheckbox: e, onKeyDown: t, onClick: r, ...o }, s) {
	let { control: c, value: u, disabled: f, checked: p, required: h, setControl: g, setChecked: _, hasConsumerStoppedPropagationRef: v, onUserInteraction: b, isFormControl: S, bubbleInput: C } = y(x, e), w = i(s, g), T = l.useRef(p);
	return l.useEffect(() => {
		let e = c?.form;
		if (e) {
			let t = /* @__PURE__ */ m(() => _(T.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [c, _]), /* @__PURE__ */ d(a.button, {
		type: "button",
		role: "checkbox",
		"aria-checked": k(p) ? "mixed" : p,
		"aria-required": h,
		"data-state": A(p),
		"data-disabled": f ? "" : void 0,
		disabled: f,
		value: u,
		...o,
		ref: w,
		onKeyDown: n(t, (e) => {
			e.key === "Enter" && e.preventDefault();
		}),
		onClick: n(r, (e) => {
			b(), _((e) => k(e) ? !0 : !e), C && S && (v.current = e.isPropagationStopped(), v.current || e.stopPropagation());
		})
	});
}, "CheckboxTrigger")), C = /* @__PURE__ */ l.forwardRef(/* @__PURE__ */ m(function(e, t) {
	let { __scopeCheckbox: n, name: r, checked: i, defaultChecked: a, required: o, disabled: s, value: c, onCheckedChange: l, form: p, ...m } = e;
	return /* @__PURE__ */ d(b, {
		__scopeCheckbox: n,
		checked: i,
		defaultChecked: a,
		disabled: s,
		required: o,
		onCheckedChange: l,
		name: r,
		form: p,
		value: c,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ f(u, { children: [/* @__PURE__ */ d(S, {
			...m,
			ref: t,
			__scopeCheckbox: n
		}), e && /* @__PURE__ */ d(D, { __scopeCheckbox: n })] })
	});
}, "Checkbox")), w = "CheckboxIndicator", T = /* @__PURE__ */ l.forwardRef(/* @__PURE__ */ m(function(e, t) {
	let { __scopeCheckbox: n, forceMount: r, ...i } = e, s = y(w, n);
	return /* @__PURE__ */ d(o, {
		present: r || k(s.checked) || s.checked === !0,
		children: /* @__PURE__ */ d(a.span, {
			"data-state": A(s.checked),
			"data-disabled": s.disabled ? "" : void 0,
			...i,
			ref: t,
			style: {
				pointerEvents: "none",
				...e.style
			}
		})
	});
}, "CheckboxIndicator")), E = "CheckboxBubbleInput", D = /* @__PURE__ */ l.forwardRef(/* @__PURE__ */ m(function({ __scopeCheckbox: e, onClick: t, ...r }, o) {
	let { control: s, hasConsumerStoppedPropagationRef: u, userInteractionCount: f, checked: p, defaultChecked: m, required: h, disabled: g, name: _, value: v, form: b, bubbleInput: x, setBubbleInput: S } = y(E, e), C = i(o, S), w = c(s), T = l.useRef(!1), D = l.useRef(p), O = l.useRef(f);
	l.useEffect(() => {
		let e = x;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "checked").set, r = f !== O.current;
		O.current = f;
		let i = D.current !== p;
		D.current = p;
		let a = !(r && u.current);
		if (i && n) {
			T.current = !r;
			let t = new Event("click", { bubbles: a });
			e.indeterminate = k(p), n.call(e, !k(p) && p), e.dispatchEvent(t), T.current = !1;
		}
	}, [
		x,
		p,
		u,
		f
	]);
	let A = l.useRef(!k(p) && p);
	return /* @__PURE__ */ d(a.input, {
		type: "checkbox",
		"aria-hidden": !0,
		defaultChecked: m ?? A.current,
		required: h,
		disabled: g,
		name: _,
		value: v,
		form: b,
		...r,
		tabIndex: -1,
		ref: C,
		onClick: n(t, (e) => {
			T.current && e.stopPropagation();
		}),
		style: {
			...r.style,
			...w,
			position: "absolute",
			pointerEvents: "none",
			opacity: 0,
			margin: 0,
			transform: "translateX(-100%)"
		}
	});
}, "CheckboxBubbleInput"));
function O(e) {
	return typeof e == "function";
}
m(O, "isFunction");
function k(e) {
	return e === "indeterminate";
}
m(k, "isIndeterminate");
function A(e) {
	return k(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
m(A, "getState");
//#endregion
//#region src/foundations/checkbox/checkbox.tsx
var j = l.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ d(C, {
	ref: r,
	className: e("grid place-content-center peer h-4 w-4 shrink-0 rounded-none border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground", t),
	...n,
	children: /* @__PURE__ */ d(T, {
		className: e("grid place-content-center text-current"),
		children: /* @__PURE__ */ d(s, { className: "h-4 w-4" })
	})
}));
j.displayName = C.displayName;
//#endregion
export { j as t };

//# sourceMappingURL=checkbox-BNSdvisy.js.map